<i18n>
  {
    "fr": {
      "details": "Coordonnées",
      "aisc-registration-number": "Numéro AISC",
      "submit": "Valider"
    },
    "en": {
      "details": "Contact details",
      "aisc-registration-number": "AISC registration number",
      "submit": "Submit"
    }
  }
</i18n>

<template>
  <v-card flat>
    <v-card-title>
      <h1 class="title">
        {{ $t('details') }}
      </h1>
      <v-spacer />
      <div
        class="overline"
      >
        {{ $t('aisc-registration-number') }}: <b>{{ customerRegistrationNumber }}</b>
      </div>
    </v-card-title>
    <v-card-text>
      <v-form>
        <FlightCustomerContactAddress />
        <v-row no-gutters>
          <v-col class="pr-2">
            <FlightCustomerContactMail />
          </v-col>
          <v-col class="pl-2">
            <FlightCustomerContactPhones />
          </v-col>
        </v-row>
      </v-form>
      <v-row
        class="mt-4"
      >
        <v-spacer />
        <v-btn
          :disabled="!canSubmit"
          color="primary"
          min-width="300px"
          @click="$emit('submitForm')"
        >
          {{ $t('submit') }}
        </v-btn>
        <v-spacer />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import FlightCustomerContactAddress from './FlightCustomerContactAddress/FlightCustomerContactAddress'
import FlightCustomerContactMail from './FlightCustomerContactMail/FlightCustomerContactMail'
import FlightCustomerContactPhones from './FlightCustomerContactPhones/FlightCustomerContactPhones'
export default {
  name: 'UserContactDetails',
  components: {
    FlightCustomerContactAddress,
    FlightCustomerContactMail,
    FlightCustomerContactPhones
  },
  props: {
    canSubmit: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      customerRegistrationNumber: 'general/getCustomerRegistrationNumber'
    })
  }
}
</script>

<style scoped>

</style>
